export default {
  message: `In order to provide a more relevant experience for you, we use cookies to enable some website functionality.  Please review our <a href="https://www.btc.si/en/terms-of-use/" target="_blank" class="underlined">Terms of Service</a> for more information.`,
  dismiss: `Accept Cookies`,
};
